<template>
  <g>
    <path
      d="M9.59943 26.5762V26.0025C9.59943 25.6798 9.47394 25.3751 9.25881 25.142L5.93332 21.6193C5.54789 21.2428 5.33276 20.723 5.33276 20.1762V13.5162C5.33276 12.7812 5.93332 12.1807 6.66834 12.1807C7.40335 12.1807 8.00391 12.7812 8.00391 13.5162V18.5807"
      :stroke="iconColor"
      stroke-width="1.7"
      stroke-miterlimit="10"
    />
    <path
      d="M11.1043 22.3089L8.35251 19.5571C7.8864 19.091 7.8864 18.3291 8.35251 17.863C8.81862 17.3969 9.58052 17.3969 10.0466 17.863L14.0982 21.9145L14.2505 22.0669C14.6808 22.4972 14.9318 23.0888 14.9318 23.7073V26.5756"
      :stroke="iconColor"
      stroke-width="1.7"
      stroke-miterlimit="10"
    />
    <path
      d="M22.3989 26.5752V26.0015C22.3989 25.6788 22.5244 25.3741 22.7395 25.141L26.065 21.6183C26.4505 21.2329 26.6656 20.713 26.6656 20.1662V13.5153C26.6656 12.7802 26.065 12.1797 25.33 12.1797C24.595 12.1797 23.9944 12.7802 23.9944 13.5153V18.5797"
      :stroke="iconColor"
      stroke-width="1.7"
      stroke-miterlimit="10"
    />
    <path
      d="M20.8931 22.3085L23.6449 19.5566C24.1111 19.0905 24.1111 18.3286 23.6449 17.8625C23.1788 17.3964 22.4169 17.3964 21.9508 17.8625L17.8993 21.9141L17.7469 22.0664C17.3167 22.4967 17.0657 23.0883 17.0657 23.7068V26.5751"
      :stroke="iconColor"
      stroke-width="1.7"
      stroke-miterlimit="10"
    />
    <path
      d="M16.0004 7.39657C14.6738 6.06996 12.5315 6.06996 11.2049 7.39657C9.87831 8.72318 9.87831 10.8655 11.2049 12.1921L16.0004 16.9876L20.796 12.1921C22.1226 10.8655 22.1226 8.72318 20.796 7.39657C19.4693 6.06996 17.3181 6.06996 16.0004 7.39657Z"
      :stroke="iconColor"
      stroke-width="1.7"
      stroke-miterlimit="10"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ee1c25"
    }
  }
};
</script>
